import { z } from "zod";
import { PaginationSchema } from "../../pagination/response/PaginationResponse";
import { BaseResponseSchema } from "../../common/response/BaseResponseSchema";
import { PropertyBankSchema } from "./ShowBankResponse";

export const IndexBankResponseSchema = BaseResponseSchema.extend({
    data: z.array(PropertyBankSchema),
    pagination: z.nullable(PaginationSchema).optional(),
})

export type IndexBankResponse = z.infer<typeof IndexBankResponseSchema>;
export type PropertyBank = z.infer<typeof PropertyBankSchema>;
